const uriApi = process.env.REACT_APP_HOST_API;

export default uriApi;
